/* ILEV · Medición de clics (Clarity + GA4 evento ilev_click) y variante A/B en <html data-ab>.
   Nombrar un botón nuevo: atributo data-ilev-ev="nombre". Probar: ?ab=B · ver envíos: ?ilev_debug=1.
   Versión comentada: 04-WEB/CODIGO-ANIVERSARIO/_optimizacion-2026-09-11/originales/assets__ilev-medicion.js
   Guía: 04-WEB/CRO/MEDICION-CLICS-Y-AB-2026-09-11.md */
(function () {
  'use strict';
  var variante = 'A';
  try {
    var forzada = new URLSearchParams(location.search).get('ab');
    if (forzada && /^[ab]$/i.test(forzada)) {
      variante = forzada.toUpperCase();
      localStorage.setItem('ilev_ab', variante);
    } else {
      variante = localStorage.getItem('ilev_ab');
      if (variante !== 'A' && variante !== 'B') {
        variante = Math.random() < 0.5 ? 'A' : 'B';
        localStorage.setItem('ilev_ab', variante);
      }
    }
  } catch (e) { variante = 'A'; }
  document.documentElement.setAttribute('data-ab', variante);
  var debug = /[?&]ilev_debug=1/.test(location.search);
  function tipoPagina() {
    var c = document.body ? document.body.className : '';
    var m = c.match(/template-(index|product|collection|cart|page|blog|article|search)\b/);
    return m ? m[1] : 'otra';
  }
  function pagina() {
    var p = location.pathname.replace(/\/+$/, '') || '/';
    return tipoPagina() + ':' + p.split('/').pop();
  }
  var TABLA = [
    ['[data-ilev-ev]', function (el) { return el.getAttribute('data-ilev-ev'); }],
    ['[data-ilev-escalera] .ilev-esc__op', function (el) {
      var i = el.querySelector('input'); return 'escalera_opcion_' + (i ? i.value : 'x');
    }],
    ['[data-ilev-buybar-cta]', 'buybar_agregar'],
    ['[data-bb-mas]', 'buybar_mas'],
    ['[data-bb-menos]', 'buybar_menos'],
    ['[data-js-product-add-to-cart]', 'ficha_agregar'],
    ['.product-actions .qty-plus', 'ficha_mas'],
    ['.product-actions .qty-minus', 'ficha_menos'],
    ['#ilevRegaloChip', 'regalo_chip'],
    ['.ilev-rg-btn', 'regalo_elegir'],
    ['.ilev-rg-saltar', 'regalo_saltar'],
    ['.ilev-rg-x', 'regalo_cerrar'],
    ['.ilev-sug', 'carrito_sugerencia'],
    ['#CheckOut, [name="checkout"]', 'carrito_pagar'],
    ['#ViewCart', 'carrito_ver'],
    ['.cart-continue', 'carrito_seguir_comprando'],
    ['#site-cart-sidebar .qty-plus, #cart .qty-plus', 'carrito_mas'],
    ['#site-cart-sidebar .qty-minus, #cart .qty-minus', 'carrito_menos'],
    ['#site-cart-sidebar .remove, #cart .remove', 'carrito_quitar'],
    ['#site-cart-sidebar [data-js-close]', 'carrito_cerrar'],
    ['[data-js-site-cart-sidebar-toggle], .header__cart, a[href$="/cart"]', 'header_carrito'],
    ['.product-item__quick-buy button, .ilev-prod__buy button', 'tarjeta_agregar'],
    ['.ilev-prod__link, .product-item__title, .product-item__image', 'tarjeta_abrir'],
    ['.ilev-cierre a.button, .ilev-cierre button', 'cierre_cta'],
    ['.ilev-barra a.button', 'barra_cta'],
    ['.ilev-faq2__q, .ilev-faq summary', 'faq_abrir'],
    ['.header__menu a, .site-nav a, nav a', function (el) {
      return 'menu_' + (el.textContent || '').trim().toLowerCase().replace(/[^a-z0-9áéíóúñ]+/g, '_').slice(0, 30);
    }]
  ];
  function nombreDe(objetivo) {
    for (var i = 0; i < TABLA.length; i++) {
      var el = objetivo.closest ? objetivo.closest(TABLA[i][0]) : null;
      if (el) {
        var n = TABLA[i][1];
        return typeof n === 'function' ? n(el) : n;
      }
    }
    return null;
  }
  function enviar(nombre, extra) {
    if (!nombre) return;
    var datos = { ilev_boton: nombre, ilev_pagina: pagina(), ilev_variante: variante };
    if (extra) for (var k in extra) datos[k] = extra[k];
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', nombre);
        window.clarity('set', 'boton', nombre);
      }
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'ilev_click', datos);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: 'ilev_click' }, datos));
      }
    } catch (e) {}
    if (debug) console.log('[ilev-medicion]', datos);
  }
  var ultClic = '', tClic = 0;
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1) t = t && t.parentElement;
    if (!t) return;
    var n = nombreDe(t), ahora = Date.now();
    /* un clic en una etiqueta dispara otro en su radio: se cuenta una vez */
    if (!n || (n === ultClic && ahora - tClic < 400)) return;
    ultClic = n; tClic = ahora;
    enviar(n);
  }, true);
  function vistaUnaVez(nombre, cuando) {
    var hecho = false, t;
    return function () {
      clearTimeout(t);
      if (hecho || !cuando()) return;
      t = setTimeout(function () { if (!hecho && cuando()) { hecho = true; enviar(nombre); } }, 600);
    };
  }
  function vigilar(selector, nombre, prueba) {
    var el = document.querySelector(selector);
    if (!el || !('MutationObserver' in window)) return;
    var v = vistaUnaVez(nombre, function () { return prueba(el); });
    v();
    new MutationObserver(v).observe(el, { attributes: true, attributeFilter: ['class', 'hidden'] });
  }
  function listo() {
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'ab', variante);
        window.clarity('set', 'pagina', tipoPagina());
      }
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('set', 'user_properties', { ilev_variante: variante });
    } catch (e) {}
    vigilar('[data-ilev-buybar]', 'ver_buybar', function (el) { return el.classList.contains('is-on'); });
    vigilar('#ilevRegaloChip', 'ver_regalo_chip', function (el) { return !el.hidden; });
    vigilar('#ilevRegaloModal', 'ver_regalo_popup', function (el) { return el.classList.contains('abierto'); });
    vigilar('#site-cart-sidebar', 'ver_carrito', function (el) { return el.classList.contains('active') || el.classList.contains('is-open') || el.style.display !== 'none'; });
    if (debug) console.log('[ilev-medicion] listo · variante', variante, '· pagina', pagina());
  }
  window.ILEV_AB = { variante: variante, medir: enviar };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', listo);
  else listo();
})();
